import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";
import Dashboard from './components/Dashboard/Dashboard';
import Loginpage from './components/Login/Login';
import User from './components/User/User';
import Useredit from './components/Useredit/Useredit';
import Resetpass from './components/Resetpass/Resetpass';
import Members from "./components/Members/Members";
import Groups from "./components/Groups/Groups";
import Coaches from "./components/Coaches/Coaches";
import Mygroups from "./components/Mygroups/Mygroups";
import MygroupsMembers from "./components/Mygroupsmembers/Mygroupsmembers";
import './App.css'
import Managemeal from "./components/Managemeal/Managemeal";
import Manageexercise from "./components/Manageexercise/Manageexercise";
import Loginadmin from "./components/Loginadmin/Loginadmin";
import Manageimages from "./components/Manageimages/Manageimages";
import { fetchSession, setProfile } from "./auth/session";

const base_url = process.env.REACT_APP_BASE_URL;

export default function App() {
  const [role, setrole] = useState(localStorage.getItem("userrole"))
  const [roleAdmin, setroleAdmin] = useState(localStorage.getItem("userroleAdmin"))
  const [current, setcurrent] = useState();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchSession(base_url);
        if (cancelled) return;
        if (data?.authenticated) {
          if (data.role === "Database Admin") {
            setProfile(data, { admin: true });
            setroleAdmin(data.role);
          } else {
            setProfile(data);
            setrole(data.role);
          }
        }
      } catch (_) {
        // unauthenticated — stay on login
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const r = role || localStorage.getItem("userrole");
    const ra = roleAdmin || localStorage.getItem("userroleAdmin");
    setrole(r);
    setroleAdmin(ra);
    if (r === 'admin') {
      setcurrent('adminuser')
    } else if (r === 'coach') {
      setcurrent('coachuser')
    } else {
      setcurrent(undefined)
    }
  }, [role, roleAdmin, ready]);

  if (!ready) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  return (
    <Router>
      <div>
        <Routes>
        <Route path="/Adminlogin" element={<RedirecttoAdmin><Loginadmin /></RedirecttoAdmin>} />
        <Route path="/Login" element={<Redirectto><Loginpage /></Redirectto>} />
          {roleAdmin==='Database Admin' ? <>
            <Route path="/Managemeal" element={<RequireAuth admin><Managemeal /></RequireAuth>} />
            <Route path="/Manageexercise" element={<RequireAuth admin><Manageexercise /></RequireAuth>} />
            <Route path="/Manageimages" element={<RequireAuth admin><Manageimages /></RequireAuth>} />
          </>
          : ''}
          {current==='adminuser' ? <>
          <Route path="/Dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/Doctors" element={<RequireAuth><Coaches /></RequireAuth>}/>
          <Route path="/Groups" element={<RequireAuth><Groups /></RequireAuth>} />
          <Route path="/Memberlist" element={<RequireAuth><MygroupsMembers /></RequireAuth>} />
          </>: ''}
          {current==='adminuser' || current==='coachuser' ? <>
          <Route path="/user/" element={<RequireAuth><User /></RequireAuth>} />
          </>: ''}
          {current==='coachuser' ? <>
          <Route path="/Mygroups" element={<RequireAuth><Mygroups /></RequireAuth>} />
          <Route path="/Memberlist" element={<RequireAuth><MygroupsMembers /></RequireAuth>} />
          </>: ''}

          {/* F2: resetpass must not be public PHI surface */}
          <Route path="/resetpass" element={<RequireAuth><Resetpass /></RequireAuth>} />
          <Route path="/" element={<Loginpage />} />

        <Route
            path="/useredit"
            element={
              <RequireAuth>
                {current==='adminuser' || current==='coachuser' ? <Useredit /> : <Navigate to="/Login" replace />}
              </RequireAuth>
            }
          />
        <Route
            path="/members"
            element={
              <RequireAuth>
                {current==='adminuser' || current==='coachuser' ? <Members /> : <Navigate to="/Login" replace />}
              </RequireAuth>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

function RequireAuth({ children, admin = false }) {
  let location = useLocation();
  const role = admin
    ? localStorage.getItem("userroleAdmin")
    : localStorage.getItem("userrole");
  // Role profile is non-secret UI state; cookie proves the session server-side.
  if (!role || role === 'undefined' || role === '') {
    return <Navigate to={admin ? "/Adminlogin" : "/Login"} state={{ from: location }} replace />;
  }
  return children;
}

function Redirectto({ children }) {
  const role = localStorage.getItem("userrole");
  let location = useLocation();
  if (role && role !== 'undefined' && role !== '') {
    return <Navigate to={role === 'coach' ? "/Mygroups" : "/Dashboard"} state={{ from: location }} replace />;
  }
  return children;
}

function RedirecttoAdmin({ children }) {
  const roleAdmin = localStorage.getItem("userroleAdmin");
  let location = useLocation();
  if (roleAdmin && roleAdmin !== 'undefined' && roleAdmin !== '') {
    return <Navigate to="/Managemeal" state={{ from: location }} replace />;
  }
  return children;
}
